import React from 'react';
import { sigla } from '../../../shared/utils/formatters/sigla.formatter';
import { Container, Header, Title } from './styles';
import { ProfessorPageQuery_alocacoes_professor } from '../../graphql/queries/__generated__/ProfessorPageQuery';
import { SearchBar } from '../../../shared/components/search_bar';
import { Table } from '../../../shared/components/table';
import { DateTime } from 'luxon';
import { Scroll } from '../../../shared/components/layout_components/scroll';
import { ButtonSelect } from '../../../shared/components/button_select';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../infrastructure/redux/store';
import { lighten } from 'polished';
import { ItemProps } from '../../../shared/components/button_select/modal';
import { PeriodosQuery_periodos } from '../../graphql/queries/__generated__/PeriodosQuery';

interface Props {
  alocacoes?: ProfessorPageQuery_alocacoes_professor[];
  periodos?: PeriodosQuery_periodos[];
  periodo?: PeriodosQuery_periodos;
  on_periodo_change: (item: ItemProps<PeriodosQuery_periodos>) => void;
}

const ProfessorAlocacoes: React.FC<Props> = (props) => {
  const { theme } = useSelector((state: RootState) => state.theme);

  const [searchTerm, setSearchTerm] = React.useState('');
  const [periodosModal, setPeriodosModal] = React.useState(false);

  const filtrar_alocacoes = () => {
    return props.alocacoes
      ? props.alocacoes
          .filter((a) =>
            a.disciplina.dsc_nome_disciplina?.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((a) => formater_alocacao(a))
      : [];
  };

  const formater_alocacao = (alocacao: ProfessorPageQuery_alocacoes_professor) => {
    return {
      dat_alocacao: DateTime.fromISO(alocacao.dat_alocacao, { setZone: true }).toMillis(),
      dsc_curso_turma:
        sigla(alocacao.oferta.curso?.dsc_nome_curso, alocacao.oferta.curso?.dsc_sigla_curso) +
        ' ' +
        (alocacao.oferta.num_oferta + '.' + alocacao.turma.num_turma),
      dsc_nome_disciplina: alocacao.disciplina.dsc_nome_disciplina,
      num_carga_horaria: alocacao.disciplina.num_carga_horaria,
      planejamento: alocacao.planejamento,
    };
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'Data',
        Cell: (props: any) => (
          <>{DateTime.fromMillis(props.cell.value, { zone: 'utc' }).toFormat('dd/MM/yyyy')}</>
        ),
        accessor: 'dat_alocacao',
        sortType: 'basic',
      },
      {
        Header: 'Curso/Turma',
        accessor: 'dsc_curso_turma',
        sortType: 'basic',
      },
      {
        Header: 'Disciplina',
        accessor: 'dsc_nome_disciplina',
        sortType: 'basic',
      },
      {
        Header: 'CH Total',
        accessor: 'num_carga_horaria',
        sortType: 'basic',
      },
    ],
    []
  );

  return (
    <Container>
      <Header>
        <Title>Alocações</Title>
        <ButtonSelect
          modalTitle={'Período'}
          modalVisible={periodosModal}
          onClick={() => setPeriodosModal(!periodosModal)}
          onSelectItem={props.on_periodo_change}
          backgroundColor={lighten(0.05, theme.colors.background)}
          textColor={theme.colors.textBackground}
          width={'200px'}
          items={props.periodos?.map((p) => ({
            id: p.id_periodo,
            label: p.dsc_periodo,
            data: p,
          }))}
        >
          {props.periodo?.dsc_periodo || 'Selecionar período'}
        </ButtonSelect>
        <SearchBar onSearch={setSearchTerm} placeholder='Filtrar alocações...' width={'230px'} />
      </Header>
      <Scroll scroll-auto>
        <Table
          data={filtrar_alocacoes()}
          columns={columns}
          getRowProps={({ original }: any) => {
            return {
              className: original.planejamento ? 'planejamento' : '',
            };
          }}
        />
      </Scroll>
    </Container>
  );
};

export { ProfessorAlocacoes };
